'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('docketDetailController', function (xeroService, docketService, orderService, jobService, addressBookService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, $q, scroll, geolocation, Upload) {
    // Main Variables For Doing Stuff
    $scope.moment = moment;
    $scope.itemEdit = null;
    $scope.data = { selectedIndex: 0 };
    $scope.newAccessor = {}

    $scope.showLineResyncing = false;

    // Base Access Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentTab = "General";

    // Filing
    $scope.singleUom = false;
    $scope.singleUomAbbreviation = ''
    $scope.totalAmount = 0;

    var timeoutSetting = 500;

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.contactSearchListFull = []
    $scope.contactSearchList = []
    $scope.contactSearchValue = ''

    $scope.contactSearch = { text: '' }

    // Include responsive utilities and UI Functionality
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    $scope.geoOptions = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 0
    };

    if ($scope.currentOrg && $scope.currentOrg.features.docketSyncing == true) {
      $scope.showLineResyncing = true;
    }

    $scope.showSaveFilingButton = function () {
      return (
        $scope.itemEdit && !$scope.itemEdit.loading && $scope.itemEdit.docketFiling && $scope.itemEdit.docketFiling.method != null
        && (
          accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets')
          || (accessControl.userHasPermission('io.docketbook.ojdapi.acceptAndFileDockets') && $scope.$parent.afterFilingAccept)
        )
      )
    }

    $scope.splitQuantityUpdated = function (activity) {
      activity.splitPercentage = parseFloat((activity.splitQuantity / $scope.totalAmount * 100).toFixed(4))
      activity.splitPercentage_display = parseFloat(activity.splitPercentage.toFixed(2))
    }

    $scope.splitPercentageUpdated = function (activity) {
      activity.splitPercentage = activity.splitPercentage_display
      if ($scope.singleUom) {
        activity.splitQuantity = parseFloat(($scope.totalAmount * activity.splitPercentage / 100).toFixed(2))
      } else {
        $scope.generateUomQuantitiesForActivities($scope.itemEdit)
      }
    }

    $scope.splitQuantityBlur = function (activity) {
      activity.splitQuantity = parseFloat(parseFloat(activity.splitQuantity).toFixed(2))
      $scope.splitQuantityUpdated(activity)
    }


    $scope.loadContactSearchList = function (searchValue) {
      if ($scope.currentOrg == null) {
        return
      }

      $scope.contactSearchLoading = true;
      $scope.promise = $q(function (resolve, reject) {
        var params = {};
        params.sort = "displayName";
        if (searchValue != null && searchValue != "") {
          params.search = searchValue;
        }

        addressBookService.getAddressBookForUnit(params, function (addressBookFull) {
          $scope.contactSearchList = addressBookFull;
          $scope.contactSearchListFull = angular.copy(addressBookFull);

          for (var i = 0; i < $scope.contactSearchList.length; i++) {
            $scope.contactSearchList[i].existing = false;
            if ($scope.existingContacts && $scope.existingContacts.length > 0) {
              for (var j = 0; j < $scope.existingContacts.length; j++) {
                if ($scope.contactSearchList[i].id == $scope.existingContacts[j].id) {
                  $scope.contactSearchList[i].existing = true;
                  break;
                }
              }
            }

            var initials = "";
            if ($scope.contactSearchList[i].displayName) {
              var split = $scope.contactSearchList[i].displayName.split(' ');
              if (split.length == 1) {
                initials = split[0].charAt(0).toUpperCase();
              } else if (split.length > 1) {
                initials = split[0].charAt(0).toUpperCase();
                initials += split[1].charAt(0).toUpperCase();
              }
            }
            $scope.contactSearchList[i].initials = initials;
            var existingXeroContact = $scope.contactSearchList[i].externalIdentifiers.find(function (eid) {
              return eid.type === 'xero';
            });
            if (existingXeroContact) {
              $scope.contactSearchList[i].xeroContact = existingXeroContact;
            }
          }
          $scope.contactSearchList = Restangular.stripRestangular($scope.contactSearchList);
          $scope.contactSearchLoading = false;
          resolve('Done');
        }, function (err) {
          $scope.contactSearchLoading = false;
          $scope.contactLoadingError = "Error getting contacts";
          reject('Error');
        });
      });
    }

    $scope.loadContactSearchList('')


    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.getCurrentDocketFromParent = function () {
      return $scope.itemEdit;
    }

    $scope.$parent.currentActiveTab = function () {
      return $scope.currentTab;
    }

    $scope.$parent.prepareForDocketFromParent = function (docketId, docket) {
      $scope.itemEdit = {};
      $scope.itemEdit.docketId = docketId;
      if (docket != null && docket.docketNumber != null) {
        $scope.itemEdit.docketNumber = docket.docketNumber;
      }
      $scope.itemEdit.loading = true;
      $scope.itemEdit.loadingType = "getting";
      $scope.itemEdit.docketFiling = { loading: true, loadingType: 'getting' };
      $scope.currentTab = "General";
      $scope.attachmentsLoading = false;
    }

    $scope.$parent.loadDocketFromParent = function (docket, openingTab, editing) {
      $scope.itemEdit = docket;
      $scope.itemEdit.loading = true;
      $scope.itemEdit.loadingType = "getting";
      if ($scope.itemEdit.templateValueStore) {
        var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
        $scope.signatureAttachments = $scope.itemEdit.attachments.reduce((acc, attachment) => {
          if (templateStoreValues.indexOf(attachment.id) !== -1) {
            acc.push(attachment.id);
          }
          return acc;
        }, []);
      }
      if ($stateParams.device == 'mobile') {
        if (openingTab) {
          $scope.currentTab = openingTab;
          $timeout(function () {
            $scope.openMobileTab(openingTab);
          }, 500);
        } else {
          $timeout(function () {
            $scope.openMobileTab("General");
          }, 500);
        }
      } else if (openingTab != null) {
        $scope.data.selectedIndex = openingTab;
      }
      $scope.itemEdit.loading = false;
      if (editing == true) {
        $scope.itemEdit.editing = true;
      } else {
        $scope.itemEdit.editing = false;
      }
      if ($stateParams.device == 'mobile' && $scope.userCanDoAction('editDocket', $scope.itemEdit)) {
        $scope.itemEdit.editing = true;
      }
      var resourceCount = $scope.itemEdit.resources.length;
      $scope.itemEdit.resources.forEach(function (item) {
        if (resourceCount <= 2) {
          item.collapsed = false;
        } else {
          item.collapsed = true;
        }
      });
      var attachmentsCount = 0;
      if ($scope.itemEdit.attachments) {
        for (var i = 0; i < $scope.itemEdit.attachments.length; i++) {
          if ($scope.itemEdit.attachments[i].fileName != 'supplier-signature' && $scope.itemEdit.attachments[i].fileName != 'customer-signature') {
            attachmentsCount += 1;
          }
        }
      }
      $scope.itemEdit.attachmentCount = attachmentsCount;
      if (
        $scope.currentOrg != null && $scope.currentOrgGroup != null &&
        (
          accessControl.userHasPermission('io.docketbook.ojdapi.fileDockets')
          || accessControl.userHasPermission('io.docketbook.ojdapi.acceptAndFileDockets')
        )
      ) {
        $scope.setupFilingDetails($scope.itemEdit);
      }
      //$scope.setupAuditLog($scope.itemEdit);
      $scope.itemEdit.signatureFields = {};
      $scope.setupChecklists($scope.itemEdit);
      // check if docket is from an order that has a xero quote referenced
      if (docket.supplierRefNo) {
        var refNoSplit = docket.supplierRefNo.split('_');
        if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
          //refNoSplit.shift();
          $scope.itemEdit.xeroQuote = true;
          $scope.itemEdit.xeroQuoteId = refNoSplit[2];
        }
      }
      $scope.loadDocketXeroInfo(docket);
      /*
      We want to not
      $timeout(function () {
        $scope.setupSummaryMap($scope.itemEdit);
      }, timeoutSetting);
      */


      var uomTypes = docket.resources.map(resource => resource.resource.uom);
      $scope.singleUom = _.uniq(uomTypes.map(uom => uom.id)).length == 1;
      if ($scope.singleUom) {
        $scope.singleUomAbbreviation = uomTypes[0].abbreviation
      }
    }

    $scope.loadDocketXeroInfo = function (docket) {
      // check if recently selected order is a xero quote
      if (!docket.xeroQuoteId && docket.supplierRefNo && docket.supplierRefNo.indexOf('xq') != -1) {
        var splits = docket.supplierRefNo.split('_');
        var xeroQuoteId = splits[2];
        docket.xeroQuoteId = xeroQuoteId;
        docket.xeroQuote = true;
        docket.xeroQuoteFull = { quoteNumber: splits[1] };
      }
      // Load most recent full Xero Quote
      if (docket.xeroQuoteId) {
        xeroService.getXeroQuote(docket.xeroQuoteId, function (quote) {
          docket.xeroQuoteFull = quote;
          // attached quote line reference to docket resources
          for (var i = 0; i < docket.resources.length; i++) {
            if (docket.resources[i].uniqueIdentifier) {
              for (var j = 0; j < quote.lineItems.length; j++) {
                if ('xql-' + quote.lineItems[j].lineItemID == docket.resources[i].uniqueIdentifier) {
                  // this is the correct quote line item
                  docket.resources[i].xeroQuoteLineItem = quote.lineItems[j];
                  break;
                }
              }
            }
          }
        }, function (err) {
          console.error('could not get xero quote', err);
        });
      }
      // get list of xero items to fetch for resources not from quote lines
      var xeroItemIds = [];
      for (var i = 0; i < docket.resources.length; i++) {
        if (docket.resources[i].uniqueIdentifier) {
          var idSplit = docket.resources[i].uniqueIdentifier.split('-');
          if (idSplit[0] == 'xi') {
            idSplit.shift();
            xeroItemIds.push(idSplit.join('-'));
          }
        }
      }
      if (xeroItemIds.length > 0) {
        xeroService.getXeroItems({ externalIds: xeroItemIds.join(',') }, function (xeroItems) {
          for (var i = 0; i < docket.resources.length; i++) {
            if (docket.resources[i].uniqueIdentifier && docket.resources[i].uniqueIdentifier.split('-')[0] == 'xi') {
              for (var j = 0; j < xeroItems.length; j++) {
                if ('xi-' + xeroItems[j].externalId == docket.resources[i].uniqueIdentifier || 'xi-' + xeroItems[j].itemID == docket.resources[i].uniqueIdentifier) {
                  docket.resources[i].xeroLineItem = xeroItems[j];
                  break;
                }
              }
            }
          }
        }, function (err) {
          console.error('could not get xero items', err);
        });
      }
    }

    $scope.$parent.newDocketFromParent = function (fromType, fromId, cb) {

      $scope.createNewDocket(null, null, fromType, fromId, cb);
    }

    $scope.$parent.newDocketWithAuthorFromParent = function (author, authorName, fromType, fromId, cb) {

      $scope.createNewDocket(author, authorName, fromType, fromId, cb);
    }

    $scope.$parent.clearDocketFromParent = function () {
      $scope.itemEdit = null;
    }

    /*****************************/
    /***** Main UI Functions *****/
    /*****************************/

    $scope.setupChecklists = function (docket) {
      if (docket.template != null) {
        docketService.validateChecklists(docket);
      }
    }

    $scope.updateDocketChecklists = function (docket) {
      docketService.validateChecklists(docket);
    }

    $scope.setupAuditLog = function (docket) {
      /*var eventLog = docket.eventLog;
      eventLog.sort(function(a,b) {
        return new Date(b.addedOn) - new Date(a.addedOn);
      });*/
    }

    // Get and setup filing details for this docket
    $scope.setupFilingDetails = function (docket) {
      docket.docketFiling = { loading: true, loadingType: 'getting' };
      docketService.getDocketFileData(docket.id, function (docketFile) {
        docket.existingDocketFile = docketFile;
        if (docket.existingDocketFile) {
          docket.docketFiling.method = docketFile.fileMethod;
        }
        if (docketFile && docketFile.createdAt) {
          docket.docketFiling.createdAt = docketFile.createdAt;
        }
        if (docketFile && docketFile.updatedAt) {
          docket.docketFiling.updatedAt = docketFile.updatedAt;
        }
        // generate resources/lines summary for docket
        var fullResourcesSummary = {};
        var linesSummary = [];
        for (var i = 0; i < docket.resources.length; i++) {
          var resourceId = docket.resources[i].resource.id;
          if (fullResourcesSummary[resourceId] == null) {
            var resourceSummary = {};
            resourceSummary.interactions = {};
            resourceSummary.resource = docket.resources[i].resource;
            fullResourcesSummary[resourceId] = resourceSummary;
          }
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            var interaction = docket.resources[i].interactions[j];
            var quantity = docket.resources[i].interactions[j].quantity;
            var resource = docket.resources[i].interactions[j].resource;
            var lineSummary = {};
            lineSummary.resource = resource;
            lineSummary.quantity = quantity;
            lineSummary.interaction = interaction;
            lineSummary.activityCodes = [];
            // get activityCode for line
            if (docket.existingDocketFile && docket.existingDocketFile.fileMethod == 'lines' && docket.existingDocketFile.lineCodes) {
              var lineCodes = docket.existingDocketFile.lineCodes;
              for (var k = 0; k < lineCodes.length; k++) {
                if (lineCodes[k].interaction.id == lineSummary.interaction.id) {
                  // got the right line code = now get the populated file code
                  if (lineCodes[k].populatedFileCodes) {
                    for (var fc = 0; fc < lineCodes[k].populatedFileCodes.length; fc++) {
                      var newActivityCode = lineCodes[k].populatedFileCodes[fc]
                      newActivityCode.percentage_display = parseFloat(newActivityCode.percentage.toFixed(2))
                      newActivityCode.quantity = parseFloat((lineSummary.interaction.quantity * newActivityCode.percentage / 100).toFixed(2))

                      lineSummary.activityCodes.push(newActivityCode);
                    }
                  }
                  break;
                }
              }
            }

            if (lineSummary.activityCodes == null || lineSummary.activityCodes.length == 0) {
              lineSummary.activityCodes = [{
                  percentage: 100,
                  percentage_display: 100,
                  quantity: quantity
              }]
            }

            linesSummary.push(lineSummary);
            if (fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] == null) {
              var interactionSummary = {};
              interactionSummary.interaction = interaction;
              interactionSummary.quantity = quantity;
              fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id] = interactionSummary;
            } else {
              fullResourcesSummary[resourceId].interactions[interaction.interactionTemplate.id].quantity += quantity;
            }
          }
        }
        docket.docketFiling.linesSummary = linesSummary;

        if ($scope.singleUom) {
          $scope.totalAmount = docket.docketFiling.linesSummary.map(line => line.quantity).reduce((a, b) => a + b, 0)
        }

        // if currently filed by split - get list of file codes and percentages to display
        var fileCodes = [];
        if (docket.existingDocketFile && docket.existingDocketFile.fileMethod == 'split') {
          if (docket.existingDocketFile.lineCodes && docket.existingDocketFile.lineCodes[0] && docket.existingDocketFile.lineCodes[0].populatedFileCodes) {
            for (var i = 0; i < docket.existingDocketFile.lineCodes[0].populatedFileCodes.length; i++) {
              var thisCode = { fileCode: docket.existingDocketFile.lineCodes[0].populatedFileCodes[i].fileCode };
              thisCode.splitPercentage = docket.existingDocketFile.lineCodes[0].populatedFileCodes[i].percentage;
              thisCode.splitPercentage_display = parseFloat(thisCode.splitPercentage.toFixed(2))
              thisCode.splitQuantity = parseFloat(($scope.totalAmount * thisCode.splitPercentage / 100).toFixed(2))
              fileCodes.push(thisCode);
            }
          }
        }
        docket.docketFiling.activityCodes = fileCodes;

        docket.docketFiling.loading = false;
        $scope.generateUomQuantitiesForActivities($scope.itemEdit);


        if ($scope.itemEdit.existingDocketFile == null) {
          $scope.changeFileMethod('split', $scope.itemEdit.docketFiling)
        }
      }, function (err) {
        docket.existingDocketFile = null;
        docket.docketFiling.loading = false;
      });
    }

    $scope.totalPercentage = function () {
      if ($scope.itemEdit == null || $scope.itemEdit.docketFiling == null || $scope.itemEdit.docketFiling.activityCodes == null) {
        return 0;
      }

      return $scope.itemEdit.docketFiling.activityCodes.map(x => Number.parseFloat(x.splitPercentage)).reduce(function (a, b) { return a + b }, 0).toFixed(2)
    }

    $scope.totalQuantity = function () {
      if ($scope.itemEdit == null || $scope.itemEdit.docketFiling == null || $scope.itemEdit.docketFiling.activityCodes == null) {
        return 0;
      }

      return $scope.itemEdit.docketFiling.activityCodes.map(x => Number.parseFloat(x.splitQuantity)).reduce(function (a, b) { return a + b }, 0).toFixed(2)
    }

    $scope.docketIsSignable = function () {
      // Check if the docket template has a signatures block
      return $scope.itemEdit.template && $scope.itemEdit.template.blocks.map(function (block) { return block.type }).includes('signatures')
    }

    // Generate map summary data and setup map
    $scope.setupSummaryMap = function (docket, method) {
      var mapDiv = "";
      if ($stateParams.previewMode == true) {
        mapDiv = ".preAuthDocketContainer #fullInteractionMap";
      } else if ($stateParams.device == 'mobile') {
        mapDiv = ".mobileListContainer #fullInteractionMap";
      } else {
        mapDiv = ".desktopContainer #fullInteractionMap";
      }
      // Get list of interaction lat/lngs to show on a map
      var map = new google.maps.Map($(mapDiv).get(0), options);
      var places = new google.maps.places.PlacesService(map);
      var infowindow = new google.maps.InfoWindow({
        content: "holding.."
      });
      var interactionMarkers = [];
      var centerPos = {};
      var bounds = new google.maps.LatLngBounds();
      if (docket.resources) {
        for (var i = 0; i < docket.resources.length; i++) {
          for (var j = 0; j < docket.resources[i].interactions.length; j++) {
            var thisInteraction = docket.resources[i].interactions[j];

            if (thisInteraction.lat && thisInteraction.long) {
              centerPos = { lat: thisInteraction.lat, lng: thisInteraction.long };
              var htmlString = "";
              if (docket.customerContact) {
                htmlString += '<p>Customer: ' + docket.customerContact.displayName + '</p>';
              }
              htmlString += '<p>Operator: ' + docket.authorName + '</p>';
              if (thisInteraction.resource) {
                htmlString += '<p>Resource: ' + thisInteraction.resource.name + '</p><p>Line Type: ' + thisInteraction.interactionName + '<p>Quantity: ' + thisInteraction.quantity + ' ' + thisInteraction.resource.uom.abbreviation + '</p>';
              }
              htmlString += '<p>' + moment(thisInteraction.createdAt).tz($scope.itemEdit.timezone).format('DD/MM/YY hh:mm a') + '</p>';
              var newMapMarker = new google.maps.Marker({
                position: { lat: thisInteraction.lat, lng: thisInteraction.long },
                title: 'Line Created Here',
                animation: google.maps.Animation.DROP,
                label: 'L',
                html: htmlString
              });
              google.maps.event.addListener(newMapMarker, 'click', function () {
                infowindow.setContent(this.html);
                infowindow.open(map, this);
              });
              var loc = new google.maps.LatLng(thisInteraction.lat, thisInteraction.long);
              bounds.extend(loc);
              interactionMarkers.push(newMapMarker);
            }
          }
        }
      }
      // Submission Marker
      if (docket.lat && docket.long) {
        var submissionMarker = new google.maps.Marker({
          position: { lat: docket.lat, lng: docket.long },
          title: 'Docket Sent Here',
          animation: google.maps.Animation.DROP,
          label: 'S'
        });
        var loc = new google.maps.LatLng(docket.lat, docket.long);
        bounds.extend(loc);
        interactionMarkers.push(submissionMarker);
      }

      // Show Interactions Map
      var options = {
        maxZoom: 18,
        disableDefaultUI: true
      };

      if (interactionMarkers.length == 0) {
        $(".fullSizeMapNoData").show();
        $(".fullSizeMapOuter").hide();

      } else {
        $(".fullSizeMapOuter").show();
        $(".fullSizeMapNoData").hide();
      }

      map.fitBounds(bounds);
      map.panToBounds(bounds);
      for (var i = 0; i < interactionMarkers.length; i++) {
        interactionMarkers[i].setMap(map);
      }
    }

    /*********************************/
    /***** Docket Data Functions *****/
    /*********************************/

    $scope.selectOrderChange = function (searchText) {
      $scope.updateOrderRef();
    }

    $scope.updateOrderRef = function () {
      docketService.updateDocketRefs($scope.itemEdit);
    }

    $scope.createNewDocket = function (author, authorName, fromType, fromId, cb) {

      var timezone = $scope.currentOrgGroup.timezone;
      if (!timezone) {
        timezone = moment.tz.guess();
      }
      var shellDocket = { 'docketNumber': 'New Docket', 'status': 'New', 'newDocket': 'true', 'authorName': $scope.currentUser.name.full, 'timezone': timezone };
      shellDocket.date = new Date();
      // setup supplier contact from org group details
      var supplierContact = {};
      supplierContact.displayName = $scope.currentOrgGroup.publicName;
      supplierContact.contactAddresses = {};
      supplierContact.addresses = [];
      if ($scope.currentOrgGroup.address != null) {
        supplierContact.addresses.push($scope.currentOrgGroup.address);
      }
      if ($scope.currentOrgGroup.emailAddress != null) {
        supplierContact.contactAddresses[$scope.currentOrgGroup.emailAddress] = [];
      }
      shellDocket.supplierContact = supplierContact;

      // If from job - get job and check users accessControl
      if (fromType == 'job' && fromId) {
        jobService.createDocketFromJob(fromId, function (newDocket) {
          cb(newDocket);
        }, function (err) {
          cb(shellDocket);
        });
      } else if (fromType == 'order' && fromId) {
        orderService.createDocketFromOrder(fromId, function (newDocket) {
          cb(newDocket);
        }, function (err) {
          cb(shellDocket);
        });
      } else {
        shellDocket.template = $scope.currentOrgGroup.defaultTemplate;
        if (author && authorName) {
          shellDocket.author = author;
          shellDocket.authorName = authorName;
        }
        // get full template
        docketService.getTemplate(shellDocket.template, function (fullTemplate) {
          shellDocket.template = fullTemplate;

          docketService.saveDocket(shellDocket, function (newDocket) {
            cb(newDocket);
          }, function (err) {
            cb(shellDocket);
          });
        }, function (err) {
          cb(shellDocket);
        });
      }
    }

    $scope.$parent.openNewDocketFromParent = function (docket) {
      $scope.openNewDocket(docket);
    }

    $scope.openNewDocket = function (newDocket) {
      $scope.itemEdit = newDocket;
      $scope.itemEdit.editing = true;
      $scope.currentTab = "General";
      $scope.updateOrderRef();
    }

    // Cancel new docket
    $scope.cancelNewDocket = function () {
      $stateParams.active = null;
      $scope.reloadWithFilters();
    }

    /*********************************/
    /**** Access Control Editing *****/
    /*********************************/

    $scope.assignDocketOrg = function (docket) {
      var assignDocket = {};
      $scope.$parent.selectOrganisationForDocket(docket, function (group) {
        if (group != null) {
          $scope.assignDocketSave(docket, group);
        }
      });
    }

    $scope.assignDocketSave = function (docket, group) {
      var losingPrincipal = $scope.currentUser.emailAddress;
      var gainingPrincipal = group.emailAddress;
      docketService.reassignDocket(docket.id, losingPrincipal, gainingPrincipal, function (success) {
        $scope.$parent.closeDocket();
        if ($stateParams.device == 'desktop') {
          $scope.$parent.loadDocketsList();
        }
      }, function (err) {
        swal({
          title: "Error!",
          text: "An error occured while reassigning the docket.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }

    $scope.shareDocket = function (docket) {
      if (docket.editing) {
        swal({
          title: "Oops!",
          text: "Please save the docket before sharing.",
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        return
      }

      var userAccessLevels = [];
      $scope.newAccessor = { 'accessLevel': 'editor' };
      $scope.contactSearch.text = ''
      if ($scope.contactSearchListFull.length == 1) {
        $scope.newAccessor.recipient = $scope.contactSearchListFull[0]
      }
      $scope.accessControlEdit = {};
      $scope.accessControlEdit.docketNumber = docket.docketNumber;
      var accessControlEdit = [];
      var currentKeys = Object.keys(docket.accessControl);
      for (var i = 0; i < currentKeys.length; i++) {
        var newAccessControlItem = {};
        newAccessControlItem.emailAddress = currentKeys[i];
        newAccessControlItem.accessLevel = "";
        if (docket.accessControl[currentKeys[i]].indexOf('creator') != -1) {
          newAccessControlItem.accessLevel = 'creator';
          newAccessControlItem.accessLevelSet = true;
        } else if (docket.accessControl[currentKeys[i]].indexOf('editor') != -1) {
          newAccessControlItem.accessLevel = 'editor';
        } else if (docket.accessControl[currentKeys[i]].indexOf('approver') != -1) {
          newAccessControlItem.accessLevel = 'approver';
        } else if (docket.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
          newAccessControlItem.accessLevel = 'viewer';
        }
        newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
        newAccessControlItem.accessLevelsArray = docket.accessControl[currentKeys[i]];

        // check if customer or supplier
        if (docket.supplierContact) {
          var addressKeys = Object.keys(docket.supplierContact.contactAddresses);
          for (var j = 0; j < addressKeys.length; j++) {
            if (newAccessControlItem.emailAddress == addressKeys[j]) {
              newAccessControlItem.isSupplier = true;
              break;
            }
          }
        }

        if (docket.customerContact) {
          var addressKeys = Object.keys(docket.customerContact.contactAddresses);
          for (var j = 0; j < addressKeys.length; j++) {
            if (newAccessControlItem.emailAddress == addressKeys[j]) {
              newAccessControlItem.isCustomer = true;
              break;
            }
          }
        }

        // check if current user and get accessLevels
        if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
          for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
            userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
          }
          newAccessControlItem.isUser = true;
        }

        // check is current org groups email and add get accessLevels
        if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
          for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
            if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
              for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
                userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
              }
              break;
            }
          }
        }
        accessControlEdit.push(newAccessControlItem);
      }

      $scope.accessControlEdit.accessControl = accessControlEdit;

      // get max accessLevel
      var maxLevel = "";
      if (userAccessLevels.indexOf('creator') != -1) {
        maxLevel = "creator";
      } else if (userAccessLevels.indexOf('editor') != -1) {
        maxLevel = "editor";
      } else if (userAccessLevels.indexOf('approver') != -1) {
        maxLevel = "approver";
      } else if (userAccessLevels.indexOf('viewer') != -1) {
        maxLevel = "viewer";
      }
      $scope.accessControlEdit.maxLevel = maxLevel;
      $mdBottomSheet.hide();
      $("#shareDocketModal").fadeIn(100);
    }

    $scope.canSetAccessLevel = function (accessor, accessLevel) {
      if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
        return false;
      }
      if (accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' ||
        $scope.accessControlEdit.maxLevel == 'approver' || $scope.accessControlEdit.maxLevel == 'editor' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' ||
        $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'remove' && accessor.accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'remove' && accessor.accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' ||
        $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'remove' && accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' ||
        $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }

      return false;
    }

    $scope.canChangeAccessLevel = function (accessor) {
      if (accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' ||
        $scope.accessControlEdit.maxLevel == 'approver' ||
        $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessor.accessLevel == 'editor' && ($scope.accessControlEdit.maxLevel == 'editor' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessor.accessLevel == 'approver' && ($scope.accessControlEdit.maxLevel == 'approver' ||
        $scope.accessControlEdit.maxLevel == 'editor' || $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessor.accessLevel == 'creator' && $scope.accessControlEdit.maxLevel == 'creator') {
        return true;
      }
    }

    $scope.closeAccessControlModal = function () {
      $("#shareDocketModal").fadeOut(100);
    }

    $scope.saveAccessControlEdit = function () {
      $scope.accessControlEdit.loading = true;
      // convert back to accessControl object
      var accessControlObject = {};
      for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
        var thisAccessItem = $scope.accessControlEdit.accessControl[i];
        if (thisAccessItem.new == true) {
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].add = [thisAccessItem.accessLevel];
        } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
          // access has been changed - need to construct add/remove fields
          if (thisAccessItem.accessLevel == 'remove') {
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          } else if (thisAccessItem.accessLevel == 'editor') {
            // construct add/remove dependent on initial array
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
            accessControlObject[thisAccessItem.emailAddress].add = ['editor'];
          } else if (thisAccessItem.accessLevel == 'approver') {
            // construct add/remove depending on initial array
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
            accessControlObject[thisAccessItem.emailAddress].add = ['approver'];
          } else if (thisAccessItem.accessLevel == 'viewer') {
            // construct ad/remove dependent on initial array
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
            accessControlObject[thisAccessItem.emailAddress].add = ['viewer'];
          }
        }
      }

      docketService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
        $scope.itemEdit.accessControl = success.accessControl;
        $("#shareDocketModal").fadeOut(100);
      }, function (err) {
        $scope.accessControlEdit.loading = false;
        swal({
          title: "Error!",
          text: "An error occured while sharing the docket.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }

    $scope.addNewAccessor = function (contactSearchValue) {
      $scope.newAccessor.loading = true;

      const emails = $scope.newAccessor.recipient
        ? $scope.newAccessor.recipient.contactAddresses.map(x => x.emailAddress)
        : [contactSearchValue]

      if (emails.length == 0) {
        swal({
          title: "Oops!",
          text: "The recipient you selected does not have any contact addresses.",
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        $scope.newAccessor.loading = false;
        return
      }

      var accessControlObject = {};

      emails.forEach(email => {
        $scope.accessControlEdit[email] = { add: $scope.newAccessor.accessLevel }
        $scope.accessControlEdit.accessControl.push({ emailAddress: email, accessLevel: $scope.newAccessor.accessLevel })

        accessControlObject[email] = {}
        accessControlObject[email].add = [$scope.newAccessor.accessLevel]
      })

      docketService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
        $scope.itemEdit.accessControl = success.accessControl;
        $scope.closeAccessControlModal()
        $scope.newAccessor.recipient = null
        $scope.newAccessor.loading = false;
      }, function (err) {
        $scope.newAccessor.loading = false;
        swal({
          title: "Error!",
          text: "An error occured while sharing the docket.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }

    $scope.selectAccessorContact = function () {
      $("#shareDocketModal").fadeOut(100);
      $scope.$parent.selectContactForShare(function (contactSelected) {
        if (contactSelected != null) {
          $("#shareDocketModal").fadeIn(100);
          /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
            $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
          }*/
          var emailAddresses = [];
          for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
            if (contactSelected.contactAddresses[i].emailAddress) {
              emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
            }
          }
          $scope.newAccessor.emailAddress = emailAddresses.join(',');
        } else {
          $("#shareDocketModal").fadeIn(100);
        }
      });
    }

    /****************************/
    /***** UI Functionality *****/
    /****************************/

    $scope.openMobileTab = function (tabName) {
      $scope.currentTab = tabName;
      if ($stateParams.device != 'desktop') {
        var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
        var width = $(".tabBarMobile.detailTabBar").width();
        var M = width / 2;
        var Y = leftOffset;
        var X = $(".tabBarMobile.detailTabBar").scrollLeft();

        if (Y > M) {
          // scroll right
          $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
        } else {
          // scroll left
          $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
        }
      }

      // Trigger background progressive save
      if ($scope.itemEdit && $scope.itemEdit.id != null) {
        $scope.progressiveSaveDocket($scope.itemEdit);
      }

      // Trigger summary map update
      if (tabName == 'Map') {
        $scope.setupSummaryMap($scope.itemEdit, 'tab');
      }
    }

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.getResourceTotalQty = function (resourceGrouped) {
      var totalQuantity = 0;
      for (var i = 0; i < resourceGrouped.interactions.length; i++) {
        if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
          if (resourceGrouped.interactions[i].interactionTemplate.billable) {
            totalQuantity += resourceGrouped.interactions[i].quantity;
          }
        } else {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      }

      totalQuantity = totalQuantity.toFixed(2);

      return totalQuantity;
    }

    $scope.getResourceQtySummary = function (resourceGrouped) {
      var totalQuantity = 0;
      for (var i = 0; i < resourceGrouped.interactions.length; i++) {
        if ($scope.itemEdit.template.sumOnlyBillableInteractions) {
          if (resourceGrouped.interactions[i].interactionTemplate.billable) {
            totalQuantity += resourceGrouped.interactions[i].quantity;
          }
        } else {
          totalQuantity += resourceGrouped.interactions[i].quantity;
        }
      }

      totalQuantity = totalQuantity.toFixed(2);

      var abbreviation = "";
      if (resourceGrouped.resource.uom && resourceGrouped.resource.uom.abbreviation) {
        abbreviation = resourceGrouped.resource.uom.abbreviation;
      }

      return totalQuantity + " " + abbreviation;
    }

    /**************************/
    /***** Assign Order *******/
    /**************************/

    // Select order
    $scope.selectOrder = function () {
      if ($scope.currentOrgGroup) {
        var supplierEmails = $scope.currentOrgGroup.emailAddresses;
      }
      var options = { currentOrder: $scope.itemEdit.orderRef, statusList: 'draft,sent,accepted', supplier: supplierEmails, hasCustomer: true };
      $scope.$parent.selectOrderForDocket(options, function (order) {
        if (order != null) {
          // get full order object
          orderService.getOrder(order.id, function (fullOrder) {
            $scope.itemEdit.orderRef = fullOrder;
            $scope.updateOrderRef();
            $scope.loadDocketXeroInfo($scope.itemEdit);
          }, function (err) {
            $scope.itemEdit.orderRef = order;
            $scope.updateOrderRef();
            $scope.loadDocketXeroInfo($scope.itemEdit);
          });
        }
      });
    }

    /**********************/
    /***** Assign Job *****/
    /**********************/

    $scope.selectJob = function () {
      $scope.$parent.selectJobForDocket({}, function (job) {
        if (job != null) {
          // get full job object
          jobService.getJob(job.id, function (fullJob) {
            $scope.itemEdit.jobRef = fullJob;
            if (fullJob.order) {
              $scope.itemEdit.orderRef = fullJob.order;
              $scope.itemEdit.orderRef.id = fullJob.order.orderId;
            }
            $scope.updateOrderRef();
          }, function (err) {
            $scope.itemEdit.jobRef = job;
            $scope.updateOrderRef();
          });
        }
      });
    }

    /***************************************/
    /***** Select Docket Template Func *****/
    /***************************************/

    // Select company - show list in sidebar
    $scope.selectDocketTemplate = function () {
      $scope.$parent.selectTemplateForDocket($scope.itemEdit.template, function (template) {
        if (template != null) {
          // get full docket template
          docketService.getTemplate(template, function (fullTemplate) {
            $scope.itemEdit.template = fullTemplate;
            docketService.setupChecklists($scope.itemEdit);
          }, function (err) {
            $scope.itemEdit.template = null;
            $scope.showToast('Error Loading Docket Template');
          });
        }
      });
    }

    /****************************************/
    /***** Select Company Functionality *****/
    /****************************************/

    $scope.additionalContactMatch = function (type) {
      if (!$scope.itemEdit.additionalContacts) {
        return undefined
      }
      return $scope.itemEdit.additionalContacts.find((con) => {
        return con.additionalContactName === type;
      })
    }

    $scope.selectCompany = function (type) {
      $scope.$parent.selectContactForDocket($scope.itemEdit, type, function (contact) {
        if (contact != null) {
          if (contact.contactAddresses != null) {
            var newContactAddresses = {};
            for (var i = 0; i < contact.contactAddresses.length; i++) {
              if (type == 'customerContact') {
                newContactAddresses[contact.contactAddresses[i].emailAddress] = ['approver'];
              } else {
                newContactAddresses[contact.contactAddresses[i].emailAddress] = ['editor'];
              }
            }

            contact.contactAddresses = newContactAddresses;
          }
          let additionalMatch = undefined;
          if ($scope.itemEdit.template && $scope.itemEdit.template.additionalContactNames) {
            additionalMatch = $scope.itemEdit.template.additionalContactNames.find((item) => {
              return item.contactName == type;
            });
          }
          if (additionalMatch !== undefined) {
            if ($scope.itemEdit.additionalContacts === undefined) {
              $scope.itemEdit.additionalContacts = [];
            }
            let existing = $scope.itemEdit.additionalContacts.find((con) => {
              return con.additionalContactName === type;
            })
            if (existing === undefined) {
              $scope.itemEdit.additionalContacts.push(Object.assign({}, contact, {
                additionalContactName: type,
              }));
            } else {
              $scope.itemEdit.additionalContacts[$scope.itemEdit.additionalContacts.indexOf(existing)] = Object.assign({}, contact, {
                additionalContactName: type,
              })
            }
          } else {
            $scope.itemEdit[type] = contact;
          }
        }
      });
    }

    /**************************************/
    /***** Add Resource Functionality *****/
    /**************************************/

    // Add a new resource to the docket
    $scope.addResource = function (method) {
      if ($stateParams.device == 'mobile') {
        $scope.$parent.selectResourceForDocket($scope.itemEdit, function (resource) {
          if (resource != null) {
            $scope.addResourceToDocket(resource, $scope.itemEdit);
          }
        });
      } else {
        $scope.$parent.selectResourceForDocket($scope.itemEdit, function (resources) {
          if (resources != null) {
            for (var i = 0; i < resources.length; i++) {
              $scope.addResourceToDocket(resources[i], $scope.itemEdit);
            }
          }
        });
      }
    }

    $scope.addResourceToDocket = function (resource, docket) {
      if (docket.resources == null) {
        docket.resources = [];
      }

      var newResourceObject = {};
      newResourceObject.resource = resource;
      newResourceObject.description = resource.lineDescription;
      newResourceObject.orderItemId = resource.orderItemId;
      if (resource.orderSupplierRef) {
        newResourceObject.uniqueIdentifier = resource.orderSupplierRef;
      } else if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled && $scope.currentOrg.planFeatures.accountingIntegrationEnabled) {
        // get xero external identifier
        if (resource.externalIdentifiers) {
          for (var i = 0; i < resource.externalIdentifiers.length; i++) {
            if (resource.externalIdentifiers[i].type == 'xero') {
              newResourceObject.uniqueIdentifier = 'xi-' + resource.externalIdentifiers[i].externalId;
            }
          }
        }
      }
      newResourceObject.collapsed = false;
      newResourceObject.interactions = [];

      // set start and end time of resource to the docket start/end time
      if (docket.startTime != null) {
        newResourceObject.startTime = docket.startTime;
      }

      if (docket.endTime != null) {
        newResourceObject.endTime = docket.endTime;
      }

      if ($stateParams.device == 'mobile') {
        $scope.temporyAddResource = newResourceObject;
        $scope.addInteractionMethod = 'temp';
        $scope.addInteractionToResource($scope.temporyAddResource);
      } else {
        $scope.addInteractionMethod = 'existing';
        docket.resources.push(newResourceObject);
      }
      $scope.loadDocketXeroInfo(docket);
    }

    $scope.addInteractionToResource = function (resource, method) {
      if (method && method == 'existing') {
        $scope.addInteractionMethod = 'existing';
        if ($stateParams.device == 'mobile') {
          $scope.itemEdit.loading = true;
          $scope.itemEdit.loadingType = 'saving';
        }
      }
      $scope.$parent.newInteractionForResource($scope.itemEdit, resource, function (newInteraction) {
        if (newInteraction == null) {
          $scope.itemEdit.loading = false;
          return;
        }

        if (resource.interactions == null) {
          resource.interactions = [];
        }

        if (newInteraction.quantityEdit === null || newInteraction.quantityEdit === undefined || isNaN(newInteraction.quantityEdit)) {
          newInteraction.quantityEdit = 0;
        }

        // strip interaction template to be only a reference
        var interactionTemplateNew = {};
        interactionTemplateNew.billable = newInteraction.interactionTemplate.billable;
        interactionTemplateNew.xeroQuantity = newInteraction.interactionTemplate.xeroQuantity;
        interactionTemplateNew.descripton = newInteraction.interactionTemplate.description;
        interactionTemplateNew.fields = newInteraction.interactionTemplate.fields;
        interactionTemplateNew.id = newInteraction.interactionTemplate.id;
        interactionTemplateNew.name = newInteraction.interactionTemplate.name;
        interactionTemplateNew.refersParent = true;
        newInteraction.interactionTemplate = interactionTemplateNew;

        // check quantity is time and convert to minutes
        if (newInteraction.resource.uom.isTime) {
          // convert quantity to minutes
          var abbreviation = newInteraction.resource.uom.abbreviation;
          if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
            // convert from hours to minutes
            newInteraction.quantity = newInteraction.quantityEdit * 60;
          }
          if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
            // display from hours&minutes to minutes
            var totalMinutes = 0;
            totalMinutes += parseInt(newInteraction.quantityHoursEdit) * 60;
            totalMinutes += parseInt(newInteraction.quantityMinutesEdit);
            newInteraction.quantity = totalMinutes;
          }
          if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
            newInteraction.quantity = newInteraction.quantityEdit;
          }
        } else {
          newInteraction.quantity = newInteraction.quantityEdit;
        }

        // Add createdAt timestamp
        newInteraction.createdAt = moment.tz($scope.itemEdit.timezone).toISOString();

        $scope.getLatestGeolcation(function (geolocation) {
          if (geolocation != null) {
            newInteraction.lat = geolocation.lat;
            newInteraction.long = geolocation.long;
          }
          resource.interactions.push(newInteraction);
          if ($scope.addInteractionMethod == 'temp') {
            $scope.itemEdit.resources.push($scope.temporyAddResource);
          }
          if ($stateParams.device == 'mobile') {
            $scope.itemEdit.loading = false;
            $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
          }
        });
      });
    }

    $scope.removeResourceFromDocket = function (resource, docket) {
      if (docket.id != null) {
        resource.delete = true;
        if ($stateParams.device == 'mobile') {
          $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
        }
      } else {
        var index = docket.resources.indexOf(resource);
        if (index != -1) {
          docket.resources.splice(index, 1);
        }
      }
    }

    $scope.removeInteractionFromResource = function (interaction, resource, cb) {
      var index = resource.interactions.indexOf(interaction);
      if (index != -1) {
        resource.interactions.splice(index, 1);
      }

      if ($stateParams.device == 'mobile') {
        $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
      }
      if (cb) {
        cb();
      }
    }

    $scope.viewInteraction = function (interaction) {

    }

    $scope.editInteraction = function (interaction, resource) {
      $scope.$parent.editInteractionForResource(interaction, $scope.itemEdit, resource, function (response) {
        if (response != null) {
          if (response.delete) {
            var index = 0;
            for (var i = 0; i < resource.interactions.length; i++) {
              if (resource.interactions[i].id == response.id) {
                index = i;
                break;
              }
            }
            if (index != -1) {
              resource.interactions.splice(index, 1);
            }
          } else {
            // check quantity is time and convert to minutes
            if (response.resource.uom.isTime) {
              // convert quantity to minutes
              var abbreviation = response.resource.uom.abbreviation;
              if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
                // convert from hours to minutes
                response.quantity = response.quantityEdit * 60;
              }
              if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
                // display from hours&minutes to minutes
                var totalMinutes = 0;
                totalMinutes += parseInt(response.quantityHoursEdit) * 60;
                totalMinutes += parseInt(response.quantityMinutesEdit);
                response.quantity = totalMinutes;
              }
              if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
                response.quantity = response.quantityEdit;
              }
            } else {
              response.quantity = response.quantityEdit;
            }
          }
          if ($stateParams.device == 'mobile') {
            $scope.progressiveSaveDocket($scope.itemEdit, 'resources');
          }
        }
      });
    }

    /******************************/
    /***** Capture Signature ******/
    /******************************/

    $scope.captureCustomerSignatureFromCustomer = function () {
      let target = $scope.$parent;
      if ('captureSignatureForDocket' in $scope) {
        target = $scope;
      }
      target.captureSignatureForDocket("Customer", true, "", true, $scope.itemEdit.template, function (signatureObject) {
        if (signatureObject != null) {
          $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
          $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
          $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
          docketService.saveMyDocketSignature($scope.itemEdit, function () {
            //alert('saved');
          }, function () {
            //alert('err');
          });
        }
      })
    }

    $scope.captureSignature = function (signatureField) {
      var nameRequired = false;
      var termsRequired = false;
      var entity = "";
      var name = "";
      if (signatureField == 'customerSignature') {
        nameRequired = true;
        termsRequired = true;
        name = "";
        entity = "Customer";
      } else {
        nameRequired = false;
        termsRequired = false;
        name = $scope.itemEdit.authorName;
        entity = "Operator";
      }

      $scope.$parent.captureSignatureForDocket(entity, nameRequired, name, termsRequired, $scope.itemEdit.template, function (signatureObject) {
        if (signatureObject != null) {
          if (signatureField == 'customerSignature') {
            $scope.itemEdit.customerSignatureData = signatureObject.signatureImage;
            $scope.itemEdit.customerSignatureImage = signatureObject.signatureImageFull;
          } else {
            $scope.itemEdit.supplierSignatureData = signatureObject.signatureImage;
            $scope.itemEdit.supplierSignatureImage = signatureObject.signatureImageFull;
          }
          if (nameRequired) {
            $scope.itemEdit.customerSignatureName = signatureObject.signatureName;
          }
        }
      });
    }

    $scope.captureFieldSignature = function (block, field) {

      $scope.$parent.captureSignatureForDocket(field.displayName, false, " ", false, $scope.itemEdit.template, function (signatureObject) {
        if (signatureObject != null) {
          if ($scope.itemEdit.signatureFields == null) {
            $scope.itemEdit.signatureFields = {};
          }
          signatureObject.blockId = block.id;
          signatureObject.fieldId = field.id;
          signatureObject.displayName = field.displayName;
          $scope.itemEdit.signatureFields[block.id + '-' + field.id] = signatureObject;
        }
      });
    }

    /***************************/
    /***** Checklist Funct *****/
    /***************************/

    $scope.openChecklistDetailModal = function (container) {
      $scope.$parent.editChecklistForDocket($scope.itemEdit.checklists, container, function (checklistsDataNew) {
        if (checklistsDataNew != null) {
          // validate checklists
          $scope.itemEdit.checklists = checklistsDataNew;
          var checklistsWithErrors = docketService.validateChecklists($scope.itemEdit);
          if ($stateParams.device == 'mobile') {
            $scope.progressiveSaveDocket($scope.itemEdit);
          }
        }
      });
    }

    /*$scope.closeWithoutSave = function(docket) {

    }*/

    /******************* OLD SEND DOCKET STUFF *****************/

    // Open send docket modal
    /*$scope.openSendDocket = function(docket) {
      $scope.docketSend = {};
      $scope.docketSend.docket = docket;
      $scope.docketSend.mode = "details";
      $("#sendDocketModal").fadeIn(100);
    }

    // Send docket to contact
    $scope.sendDocket = function(docketSend) {
      $scope.docketSend.mode = "sending";

      var url = '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docketSend.docket.id + '/generatepdf';
      $http.post(url, {emails: docketSend.contacts})
        .success(function(data, status, headers, config) {
          $scope.docketSend.mode = "sent";
        }).error(function(data, status, header, config) {
          $scope.docketSend.mode = "sendError";
        });
    }

    $scope.restartSendDocket = function() {
      $scope.docketSend.mode = "details";
    }

    // Close send docket modal
    $scope.closeSendDocket = function() {
      $scope.docketSend = {};
      $("#sendDocketModal").fadeOut(100);
    }*/

    // Add contact to docketSend contacts
    $scope.addContactToSend = function (docketSend, newContact) {
      if (docketSend.contacts == null) {
        docketSend.contacts = [];
      }

      docketSend.contacts.push(newContact);
      docketSend.newContact = "";
    }

    $scope.downloadDocket = function (docket) {
      var url = "";
      if ($scope.currentOrg != null) {
        url = DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
      } else {
        url = DOCKETBOOK_API_URL + "/" + $scope.urlVersion + '/dockets/' + docket.id + '/downloadpdf';
      }
      window.open(url, "_blank");
    }

    /********************************/
    /**** OTHER UI FUNC - CHECK *****/
    /********************************/

    // Check if item editability is closed (by status)
    $scope.itemEditClosed = function (docket) {
      if (docket != null) {
        if (docket.status == 'Sent' || docket.status == 'Accepted' || docket.editing == false) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    // Validate Docket Before Submission
    $scope.validateDocket = function (docket, cb) {
      // VALIDATE CHECKLISTS
      var checklistsWithErrors = docketService.validateChecklists(docket, "beforeSubmission");

      if (checklistsWithErrors.length > 0) {
        swal({
          title: "Error!",
          text: "Some checklists that are required have not been completed fully.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        cb(false);
        return;
      }

      //TODO: VALIDATE RESOURCES

      // VALIDATE CUSTOMER
      if (docket.customer == null && docket.customerContact == null) {
        swal({
          title: "Error!",
          text: "A customer must be added before sending a docket.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
        cb(false);
        return;
      }

      cb(true);
    }

    /*******************************/
    /***** Attachment Uploader *****/
    /*******************************/

    $scope.attachmentFile = {};

    $scope.uploadNewAttachment = function ($file) {
      $scope.attachmentsLoading = true;
      $scope.progressiveSaveInProcess = true;
      Upload.upload({
        method: 'PUT',
        url: DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets/" + $scope.itemEdit.id + "/attachment",
        data: { file: $file },
        withCredentials: true
      }).then(function (resp) {
        $scope.progressiveSaveInProcess = false;
        docketService.getDocket($scope.itemEdit.id, false, function (docketUpdated) {
          $scope.itemEdit.attachments = docketUpdated.attachments;
          var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
          $scope.signatureAttachments = $scope.itemEdit.attachments.reduce((acc, attachment) => {
            if (templateStoreValues.indexOf(attachment.id) !== -1) {
              acc.push(attachment.id);
            }
            return acc;
          }, []);

          $scope.attachmentsLoading = false;
        }, function (err) {
          $scope.attachmentsLoading = false;
        });
      }, function (resp) {
        $scope.progressiveSaveInProcess = false;
        $scope.alertService.presentAutoAlert('uploadDocketAttachment', resp);
        $scope.attachmentsLoading = false;
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
      });
    }

    $scope.openAttachment = function (attachment) {
      if ($scope.currentOrg != null) {
        window.open(DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + $scope.itemEdit.id + '/attachment/' + attachment.id);
      } else {
        window.open(DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/dockets/' + $scope.itemEdit.id + '/attachment/' + attachment.id);
      }
    }

    $scope.openTemplateAttachment = function (attachment) {
      if ($scope.currentOrg != null) {
        window.open(DOCKETBOOK_API_URL + '/' + $scope.urlVersion + '/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/templates/' + $scope.itemEdit.template.id + '/attachment/' + attachment.id);
      }
    }

    $scope.deleteAttachment = function (attachment) {
      $scope.attachmentsLoading = true;
      var baseAttachment = Restangular.all('organisations').one($scope.currentOrg.id).all('groups').one($scope.currentOrgGroup.id).all('dockets').one($scope.itemEdit.id).all('attachment').one(attachment.id);
      baseAttachment.remove().then(function (success) {
        docketService.getDocket($scope.itemEdit.id, false, function (docketUpdated) {
          $scope.itemEdit.attachments = docketUpdated.attachments;
          var templateStoreValues = Object.values($scope.itemEdit.templateValueStore);
          $scope.signatureAttachments = $scope.itemEdit.attachments.reduce((acc, attachment) => {
            if (templateStoreValues.indexOf(attachment.id) !== -1) {
              acc.push(attachment.id);
            }
            return acc;
          }, []);
          $scope.attachmentsLoading = false;
        }, function (err) {
          $scope.attachmentsLoading = false;
        });
      }, function (err) {
        swal({
          title: "Delete Failed",
          text: "An error occured while deleting your attachment. Please try again.",
          type: "error",
          confirmButtonText: "Ok."
        });
        $scope.attachmentsLoading = false;
      });
    }

    /*****************************/
    /***** File Code Methods *****/
    /*****************************/

    $scope.searchFileCodes = function (searchText) {
      return $q(function (resolve, reject) {
        var params = {};
        if (searchText != null) {
          if (searchText != "") {
            params.search = searchText;
          } else {
            resolve([]);
            return;
          }
        }
        docketService.getFileCodes(params, function (fileCodes) {
          resolve(fileCodes);
        }, function (err) {
          reject("err");
        });
      });
    }

    $scope.changeFileMethod = function (method, docketFiling) {
      if (method == 'split') {
        if (docketFiling.activityCodes == null) {
          docketFiling.activityCodes = [];
        }
        if (docketFiling.activityCodes.length == 0) {
          $scope.addSplitFileCodeDesktop();
        }
      }

      docketFiling.method = method;
    }

    $scope.addSplitFileCodeDesktop = function () {
      if ($scope.itemEdit.docketFiling.activityCodes == null) {
        $scope.itemEdit.docketFiling.activityCodes = [];
      }

      var totalPercentage = 0;
      for (var i = 0; i < $scope.itemEdit.docketFiling.activityCodes.length; i++) {
        if ($scope.itemEdit.docketFiling.activityCodes[i].splitPercentage) {
          totalPercentage += $scope.itemEdit.docketFiling.activityCodes[i].splitPercentage;
        }
      }

      var remainingPercentage = 0;
      if (totalPercentage < 100) {
        remainingPercentage = parseFloat((100 - totalPercentage).toFixed(2))
      }

      const splitQuantity = parseFloat(($scope.totalAmount * remainingPercentage / 100).toFixed(2))
      $scope.itemEdit.docketFiling.activityCodes.push({ splitPercentage: remainingPercentage, fileCode: null, splitQuantity });

      $scope.generateUomQuantitiesForActivities($scope.itemEdit)
    }

    $scope.removeSplitFileCode = function (activityCode) {
      var index = $scope.itemEdit.docketFiling.activityCodes.indexOf(activityCode);
      if (index != -1) {
        $scope.itemEdit.docketFiling.activityCodes.splice(index, 1);
      }
    }

    $scope.selectActivityCodeChange = function () {
      $scope.generateUomQuantitiesForActivities($scope.itemEdit);
    }

    $scope.generateUomQuantitiesForActivities = function (docket) {
      // only generate if docket items are all of the same UOM
      var uomSummaries = {};
      for (var i = 0; i < docket.resources.length; i++) {
        if (uomSummaries[docket.resources[i].resource.uom.id] == null) {
          uomSummaries[docket.resources[i].resource.uom.id] = { sumQuantity: 0, uom: docket.resources[i].resource.uom };
        }

        // get sumQuantity for this resource
        var interactionsSumQuantity = 0;
        for (var j = 0; j < docket.resources[i].interactions.length; j++) {
          interactionsSumQuantity += docket.resources[i].interactions[j].quantity;
        }
        uomSummaries[docket.resources[i].resource.uom.id].sumQuantity += interactionsSumQuantity;
      }

      for (var i = 0; i < docket.docketFiling.activityCodes.length; i++) {
        // generate uom summary based on the splitPercentage for this activity
        var activityUomSummary = {};
        for (var uom in uomSummaries) {
          activityUomSummary[uom] = { uom: uomSummaries[uom].uom, splitQuantity: (docket.docketFiling.activityCodes[i].splitPercentage / 100) * uomSummaries[uom].sumQuantity };
        }
        docket.docketFiling.activityCodes[i].uomSummaries = activityUomSummary;
      }
    }

    $scope.selectActivityForLine = function (docketFiling, line) {
      var existing = [];
      if (line.activityCode != null) {
        existing.push(line.activityCode);
      }
      $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
        if (activity != null) {
          line.activityCode = activity;
        }
      });
    }

    $scope.getLineTotalPercent = function(line) {
      return line.activityCodes
        .map(activityCode => activityCode.percentage)
        .reduce((a, b) => a + b, 0)
    }

    $scope.splitLineFiling = function (line) {
      const remainingPercent = 100 - $scope.getLineTotalPercent(line)

      line.activityCodes.push({
          percentage: remainingPercent,
          percentage_display: parseFloat(remainingPercent.toFixed(2)),
          quantity: parseFloat((line.quantity * remainingPercent / 100).toFixed(2))
      })
    }

    $scope.removeSplitLineFiling = function(line, index) {
      line.activityCodes.splice(index, 1);
      if (line.activityCodes.length == 1) {
        line.activityCodes[0].percentage = 100;
      }
    }

    $scope.activityCodePercentageUpdated = function(line, activityCode, index) {
      activityCode.percentage = activityCode.percentage_display
      activityCode.quantity = parseFloat((line.quantity * activityCode.percentage / 100).toFixed(2))

      if (line.activityCodes.length == 2) {
        const otherActivityCode = line.activityCodes[index == 0 ? 1 : 0]
        otherActivityCode.percentage = 100 - activityCode.percentage
        otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2))
        otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2))
      }
    }

    $scope.activityCodeQuantityUpdated = function(line, activityCode, index) {
      activityCode.percentage = parseFloat((activityCode.quantity / line.quantity * 100).toFixed(4))
      activityCode.percentage_display = parseFloat(activityCode.percentage.toFixed(2))

      if (line.activityCodes.length == 2) {
        const otherActivityCode = line.activityCodes[index == 0 ? 1 : 0]
        otherActivityCode.percentage = 100 - activityCode.percentage
        otherActivityCode.percentage_display = parseFloat(otherActivityCode.percentage.toFixed(2))
        otherActivityCode.quantity = parseFloat((line.quantity * otherActivityCode.percentage / 100).toFixed(2))
      }
    }



    $scope.selectActivityForSplit = function (docketFiling, activityCode) {
      // get list of used file codes
      var existing = [];
      if (docketFiling.activityCodes != null) {
        for (var i = 0; i < docketFiling.activityCodes.length; i++) {
          if (docketFiling.activityCodes[i].fileCode != null) {
            existing.push(docketFiling.activityCodes[i].fileCode);
          }
        }
      }
      $scope.$parent.selectActivityForDocketFile(existing, function (activity) {
        if (activity != null) {
          activityCode.fileCode = activity;
        }
      });
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.selectDateTime = function (type, dateObject, dateField) {
      if (type == 'DateTime' || type == 'Date') {
        $mdpDatePicker(dateObject[dateField]).then(function (selectedDate) {
          dateObject[dateField] = selectedDate;
        });
      } else if (type == 'Time') {
        $mdpTimePicker(dateObject[dateField], {
          autoSwitch: true
        }).then(function (selectedTime) {
          dateObject[dateField] = selectedTime;
        });
      }
    }

    $scope.showDatePicker = function (field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function (field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function (selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /***********************/
    /**** Bottom Sheet *****/
    /***********************/

    $scope.openBottomSheet = function () {
      $mdBottomSheet.show({
        templateUrl: 'views/pages/dockets/mobile/docketsBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function () {

      });
    }

    /***********************************/
    /****** Get latest geolcation ******/
    /***********************************/

    $scope.getLatestGeolcation = function (cb) {
      var afterGeolocateCallback = cb;
      if ($scope.lastGeolocation.lat != null) {
        afterGeolocateCallback($scope.lastGeolocation);
        afterGeolocateCallback = null;
        return;
      } else {

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (data) {
            var coords = data.coords;
            var geolocation = {};
            geolocation.lat = coords.latitude;
            geolocation.long = coords.longitude;

            if (afterGeolocateCallback) {
              afterGeolocateCallback(geolocation);
              afterGeolocateCallback = null;
            }
            return;
          }, function (err) {
            if (afterGeolocateCallback) {
              afterGeolocateCallback(null);
              afterGeolocateCallback = null;
            }
            return;
          }, { enableHighAccuracy: true, timeout: 5000 });
        } else {

          if (afterGeolocateCallback) {
            afterGeolocateCallback(null);
            afterGeolocateCallback = null;
          }
          return;
        }
      }
    }

    /************************/
    /**** New Xero tools ****/
    /************************/

    $scope.xeroDisplayUnitPrices = function () {
      if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.displayUnitPrices) {
        return true;
      } else {
        return false;
      }
    }

    $scope.calculateResourceXeroTotalPrice = function (resource) {
      var unitPrice = 0;
      if (resource.xeroQuoteLineItem) {
        unitPrice = resource.xeroQuoteLineItem.unitAmount;
      } else if (resource.xeroLineItem) {
        unitPrice = resource.xeroLineItem.salesDetails.unitPrice;
      }

      var totalQuantity = $scope.getResourceTotalQty(resource);
      if (unitPrice >= 0 && totalQuantity >= 0) {
        var totalPrice = unitPrice * totalQuantity;
        totalPrice = totalPrice.toFixed(2);
        return totalPrice;
      } else {
        return 0;
      }
    }

    /**************************************/
    /**** Receiver Docket Line Syncing ****/
    /**************************************/

    $scope.findOrderLineForItem = function (resource) {
      if ($scope.itemEdit.orderRef && $scope.itemEdit.orderRef.lineItems) {
        var orderItemFound = null;
        for (var i = 0; i < $scope.itemEdit.orderRef.lineItems.length; i++) {
          if (resource.orderItemId == $scope.itemEdit.orderRef.lineItems[i].id) {
            orderItemFound = $scope.itemEdit.orderRef.lineItems[i];
            return orderItemFound;
          }
        }
      }

      return null;
    }

    $scope.linkOrderLineForResource = function (resource) {
      $scope.orderLineSelectFromParent($scope.itemEdit.orderRef.lineItems, function (lineItemSelected) {

        if (lineItemSelected != null) {
          // patch up the line item ref on this resource
          resource.orderItemId = lineItemSelected.id;
          resource.description = lineItemSelected.itemDescription;
          // trigger save of this docket now
          if (!$scope.itemEdit.editing) {
            $scope.saveDocket($scope.itemEdit, function () {
              $scope.$parent.loadDocketFromParent($scope.itemEdit, 0, $scope.itemEdit.editing)
            });
          }
        }
      });
    }

    /***********************************/
    /***** Alert Parent Controller *****/
    /***********************************/

    $scope.$parent.detailControllerReady();

  });



// WEBPACK FOOTER //
// ./src/controllers/dockets/detailController.js